import { setRecoil } from 'recoil-nexus';

import { ambientListeningIntelligenceChatId } from 'components/practice/charts/ClinicalNote/MyScribeAI/Templates/AmbientListening/state';
import myScribeAiState from 'components/practice/charts/ClinicalNote/MyScribeAI/state';

const updateSpecialty = (data) => {
  const { specialty, intelligence_chat_id, vertical } = data;
  if (intelligence_chat_id) {
    if (vertical === 'auto_map')
      setRecoil(myScribeAiState.intelligenceChatIdState, intelligence_chat_id);
    if (vertical === 'ambient_listening')
      setRecoil(ambientListeningIntelligenceChatId, intelligence_chat_id);
  }

  if (specialty) setRecoil(myScribeAiState.specialtyState, specialty);
};

export default updateSpecialty;
